module.exports = fox._r("images/reg_left_urban.png", __webpack_public_path__ + "images/reg_left_urban.png");


//////////////////
// WEBPACK FOOTER
// ./images/reg_left_urban.png
// module id = 524
// module chunks = 2